import { useReducer } from 'react'
import {
  DEFAULT_LAT,
  DEFAULT_LON,
  DEFAULT_RADIUS_IN_METERS,
  DEFAULT_ADDRESS
} from '@/modules/accredited-establishments/constants'
import { FiltersAction, FiltersState } from './useFiltersReducer.types'
import {
  updateAddress,
  updateClusterLocation,
  updateEstablishmentListLocation,
  updateMarkerLocation,
  updateFilters,
  initFilters,
  updateCoordinates,
  setProviderName
} from './useFiltersReducer.helpers'

const useFiltersReducer = () => {
  const [filters, filtersDispatch] = useReducer(
    filtersReducer,
    initialFiltersState
  )

  return {
    filters,
    filtersDispatch
  }
}

const initialFiltersState: FiltersState = {
  ready: false,
  view: 'list',
  filterPresentation: 'expanded',
  providerSearchOpen: false,
  categories: [],
  plan: undefined,
  specialty: undefined,
  subSpecialty: undefined,
  gender: undefined,
  appointmentType: undefined,
  providerName: undefined,
  address: undefined,
  markerLocation: {
    type: 'coordinates',
    lat: DEFAULT_LAT,
    lon: DEFAULT_LON,
    radiusInMeters: DEFAULT_RADIUS_IN_METERS
  },
  clusterLocation: null,
  establishmentListLocation: {
    type: 'address',
    address: DEFAULT_ADDRESS
  }
}

const filtersReducer = (
  state: FiltersState,
  action: FiltersAction
): FiltersState => {
  switch (action.type) {
    case 'INIT_FILTERS':
      return initFilters(state, action.payload)
    case 'SET_PROVIDER_NAME':
      return setProviderName(state, action.payload)
    case 'UPDATE_FILTERS':
      return updateFilters(state, action.payload)
    case 'UPDATE_MARKER_LOCATION':
      return updateMarkerLocation(state, action.payload)
    case 'UPDATE_CLUSTER_LOCATION':
      return updateClusterLocation(state, action.payload)
    case 'UPDATE_ESTABLISHMENT_LIST_LOCATION':
      return updateEstablishmentListLocation(state, action.payload)
    case 'UPDATE_COORDINATES':
      return updateCoordinates(state, action.payload)
    case 'UPDATE_ADDRESS':
      return updateAddress(state, action.payload)
    case 'SET_VIEW':
      return {
        ...state,
        view: action.payload
      }
    case 'MARK_AS_READY':
      return {
        ...state,
        ready: true
      }
    case 'SET_PROVIDER_SEARCH_OPEN':
      return {
        ...state,
        providerSearchOpen: action.payload
      }
    case 'SET_FILTER_PRESENTATION':
      return {
        ...state,
        filterPresentation: action.payload
      }
    case 'CLEAR_FILTERS':
      return {
        ...state,
        categories: [],
        plan: undefined,
        specialty: undefined,
        subSpecialty: undefined,
        gender: undefined,
        appointmentType: undefined,
        providerName: undefined,
        providerSearchOpen: false
      }
    default:
      return state
  }
}

export { useFiltersReducer, initialFiltersState }
